import { render } from "./EarnVaults.vue?vue&type=template&id=453b6aa4&scoped=true"
import script from "./EarnVaults.vue?vue&type=script&lang=js"
export * from "./EarnVaults.vue?vue&type=script&lang=js"

import "./EarnVaults.vue?vue&type=style&index=0&id=453b6aa4&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453b6aa4"],['__file',"resources/js/components/EarnVaults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "453b6aa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('453b6aa4', __exports__)) {
    api.reload('453b6aa4', __exports__)
  }
  
  module.hot.accept("./EarnVaults.vue?vue&type=template&id=453b6aa4&scoped=true", () => {
    api.rerender('453b6aa4', render)
  })

}


export default __exports__